/* eslint-disable */
import React, { useState, useEffect } from 'react';


import {
  Button,
  Fade,
  Popper,
  makeStyles,
  createStyles,
  ClickAwayListener,
  Paper,
  Select, 
  MenuItem, 
  Checkbox, 
  ListItemText, 
  FormControl, 
  FormLabel, 
  Box, 
  Chip,
  Grid,
  Typography,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import VisibilityIcon from '@material-ui/icons/Visibility';
import axios from 'axios';
import moment, { Moment } from 'moment';
import { useIntl } from 'react-intl';

import { getGroups } from 'actions';
import AsyncMultiSelect from 'app/components/shared/async-multi-select';
import { FiltersDateRangeSelector } from 'app/components/shared/filter-date-range-selectors';
import FilterTextField from 'app/components/shared/filter-text-field';
import { basicButtonStyles, mainButtonStyles } from 'app/shared/styles';

import CloseIcon from './close-icon.svg';
import FilterIcon from './filter_alt_black.svg';
import lightFilterIcon from './filter_alt_white.svg';

export const TripSalesFilterParams = {
  driver: 'driver_username_or_driver_first_name_or_driver_last_name_cont_any',
  axis: 'axis_code_cont_any',
  vehicle: 'vehicle_code_cont_any',
  groups: 'groups',
  minDate: 'created_at_gteq',
  maxDate: 'created_at_lteq',
  minDateObc: 'obc_time_gteq',
  maxDateObc: 'obc_time_lteq',
  discountBandCode: 'discount_band_code_cont_any',
  discountBandAssignments: 'discount_band_assignments_id_in',
  isOffline: 'is_offline_eq',
};

const useStyles = makeStyles(() =>
  createStyles({
    multiActionButton: {
      ...mainButtonStyles,
      height: 40,
      padding: '4px 18px',
      borderColor: '#DFE4EA',
      '&:hover': {
        opacity: 1,
      },
    },
    paperStyle: {
      width: 720,
      maxHeight: '90vh',
      overflowY: 'auto',
      backgroundColor: '#F4F6FB',
      padding: '20px',
      paddingTop: '25px',
      paddingBottom: '25px',
      borderRadius: 15,
      boxShadow: '0px 2px 10px 0px rgba(0, 0, 0, 0.2)',
    },
    popperStyle: {
      marginTop: 6,
      zIndex: 10,
    },
    closeFilters: {
      marginRight: 10,
      cursor: 'pointer',
      '& :hover': {
        opacity: 0.7,
      },
    },
    basicButton: { ...basicButtonStyles },
    filterIcon: {
      marginRight: 10,
    },
    resetButton: {
      color: '#5572FA',
      width: 85,
      height: 37,
      fontSize: 13,
      fontWeight: 700,
    },
  })
);

function Filters({
  filterTripSales,
  filters,
  setFilters,
  setAppliedFilters,
  isApplied,
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [assignmentOptions, setAssignmentOptions] = useState<any[]>([]);
  const [viewingAssignment, setViewingAssignment] = useState<any | null>(null);

  const id = open ? 'simple-popper' : undefined;
  const classes = useStyles();
  const intl = useIntl();

  const handleClick = event => {
    const { currentTarget } = event;
    setAnchorEl(currentTarget);
    setOpen(!open);
  };

  const handleClickAway = () => setOpen(false);

  useEffect(() => {
    // Fetch discount band assignments for the dropdown
    // Auth: the Node.js middleware (verifyTokenEasyFaraApis_accessTokenClientUidKeysBased_admins)
    // reads access-token, client, uid headers — NOT Authorization Bearer
    let userAuthData: any = null;
    try {
      const localAuthData = localStorage.getItem('authData');
      if (localAuthData) {
        const parsed = JSON.parse(localAuthData);
        userAuthData = parsed?.userToken;
      }
    } catch (e) { /* ignore */ }

    axios.get(`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/discount_band_assignment`, {
      params: { limit: 200 },
      headers: {
        'access-token': userAuthData?.['access-token'] || userAuthData?.access_token,
        'uid': userAuthData?.uid,
        'client': userAuthData?.client,
      }
    })
      .then(res => setAssignmentOptions(res.data?.data?.discountBandAssignments || res.data?.data || []))
      .catch(console.error);
  }, []);

  const handleAddedFilters = (
    filterName: string,
    selectedFilters: string[] | string | undefined | Moment
  ) => {
    let updatedFilters = { ...filters };
    if (
      (Array.isArray(selectedFilters) && !selectedFilters?.length) ||
      !selectedFilters
    ) {
      delete updatedFilters[filterName];
    } else {
      updatedFilters[filterName] = selectedFilters;
    }

    return setFilters(updatedFilters);
  };

  return (
    <div>
      <Button
        aria-describedby={id}
        variant="outlined"
        color="default"
        type="button"
        className={classes.multiActionButton}
        onMouseUp={undefined}
        onMouseDown={handleClick}
        style={{
          backgroundColor: isApplied ? '#4b506D ' : '#fff',
          color: isApplied ? '#fff' : '#4b506D',
        }}
      >
        <img
          src={isApplied ? lightFilterIcon : FilterIcon}
          alt="filter drivers"
          className={classes.filterIcon}
        />

        {intl.formatMessage({ id: 'filter' })}
      </Button>

      <Popper
        id={id}
        open={open}
        placement="bottom-start"
        anchorEl={anchorEl}
        transition
        className={classes.popperStyle}
      >
        {({ TransitionProps }) => (
          <ClickAwayListener
            onClickAway={handleClickAway}
            mouseEvent="onMouseDown"
          >
            <Fade {...TransitionProps} timeout={350}>
              <Paper variant="outlined" className={classes.paperStyle}>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <span
                    style={{
                      color: '#444',
                      fontSize: 15,
                      fontWeight: 500,
                      paddingBottom: 10,
                    }}
                  >
                    {intl.formatMessage({ id: 'filters' }).toUpperCase()}
                  </span>

                  <span
                    onClick={() => setOpen(false)}
                    onKeyDown={() => setOpen(false)}
                    role="button"
                    tabIndex={0}
                    className={classes.closeFilters}
                  >
                    <img src={CloseIcon} alt="close filters" />
                  </span>
                </div>

                <div style={{ marginTop: 15 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <FilterTextField
                        placeholder="أحمد توفيق 5217, عبدالعزيز محمود 2219"
                        label="driver"
                        sendSelectedOptions={(filterName, selectedValue) =>
                          handleAddedFilters(filterName, selectedValue)
                        }
                        filterName={TripSalesFilterParams.driver}
                        value={filters[TripSalesFilterParams.driver]}
                      />

                      <FilterTextField
                        placeholder="NC1, NC2"
                        label="axis"
                        sendSelectedOptions={(filterName, selectedValue) =>
                          handleAddedFilters(filterName, selectedValue)
                        }
                        filterName={TripSalesFilterParams.axis}
                        value={filters[TripSalesFilterParams.axis]}
                      />

                        <FiltersDateRangeSelector
                          minDateValue={filters?.[TripSalesFilterParams.minDate]}
                          maxDateValue={filters?.[TripSalesFilterParams.maxDate]}
                          minDateFilterName={TripSalesFilterParams.minDate}
                          maxDateFilterName={TripSalesFilterParams.maxDate}
                          minLabel={intl.formatMessage({ id: 'createdAtFromDate' })}
                          maxLabel={intl.formatMessage({ id: 'createdAtToDate' })}
                          onChangeMinDate={(filterName, date) =>
                            handleAddedFilters(filterName, date)
                          }
                          onChangeMaxDate={(filterName, date) =>
                            handleAddedFilters(filterName, date)
                          }
                        />

                        <FiltersDateRangeSelector
                          minDateValue={filters?.[TripSalesFilterParams.minDateObc]}
                          maxDateValue={filters?.[TripSalesFilterParams.maxDateObc]}
                          minDateFilterName={TripSalesFilterParams.minDateObc}
                          maxDateFilterName={TripSalesFilterParams.maxDateObc}
                          minLabel={intl.formatMessage({ id: 'obcFromDate' })}
                          maxLabel={intl.formatMessage({ id: 'obcToDate' })}
                          onChangeMinDate={(filterName, date) =>
                            handleAddedFilters(filterName, date)
                          }
                          onChangeMaxDate={(filterName, date) =>
                            handleAddedFilters(filterName, date)
                          }
                        />
                    </Grid>
                    
                    <Grid item xs={6}>
                      <FilterTextField
                        placeholder="Bnd-123"
                        label="discountBandCode"
                        sendSelectedOptions={(filterName, selectedValue) =>
                          handleAddedFilters(filterName, selectedValue)
                        }
                        filterName={TripSalesFilterParams.discountBandCode}
                        value={filters[TripSalesFilterParams.discountBandCode]}
                      />

                      <FilterTextField
                        placeholder="347, 546"
                        label="vehicle"
                        sendSelectedOptions={(filterName, selectedValue) =>
                          handleAddedFilters(filterName, selectedValue)
                        }
                        filterName={TripSalesFilterParams.vehicle}
                        value={filters[TripSalesFilterParams.vehicle]}
                      />

                      <FormControl fullWidth style={{ marginBottom: 22 }}>
                        <FormLabel style={{ fontSize: 13, marginBottom: 8, color: '#030229' }}>
                          {intl.formatMessage({ id: 'isOffline' }) || 'Is Offline'}
                        </FormLabel>

                        <Select
                          value={filters?.[TripSalesFilterParams.isOffline] ?? ''}
                          variant="outlined"
                          displayEmpty
                          SelectDisplayProps={{
                            style: { backgroundColor: 'white', padding: '5px 5px', minHeight: 40 }
                          }}
                          onChange={(e) =>
                            handleAddedFilters(TripSalesFilterParams.isOffline, e.target.value as string)
                          }
                        >
                          {/* Empty value => no filter => show all regardless of flag */}
                          <MenuItem value="">{intl.formatMessage({ id: 'all' })}</MenuItem>
                          <MenuItem value="false">{intl.formatMessage({ id: 'online' }) || 'Online'}</MenuItem>
                          <MenuItem value="true">{intl.formatMessage({ id: 'offline' }) || 'Offline'}</MenuItem>
                        </Select>
                      </FormControl>

                      <AsyncMultiSelect
                        sendSelectedOptions={(filterName, selectedFilters) =>
                          handleAddedFilters(filterName, selectedFilters)
                        }
                        selected={filters?.[TripSalesFilterParams.groups] || []}
                        label="group"
                        entity={TripSalesFilterParams.groups}
                        action={() => getGroups(0, 100)}
                        addBottomMargin
                      />

                      <FormControl fullWidth style={{ marginBottom: 22 }}>
                        <FormLabel style={{ fontSize: 13, marginBottom: 8, color: '#030229' }}>
                          {intl.formatMessage({ id: 'discountBandAssignments' }) || 'Discount Band Assignments'}
                        </FormLabel>

                        <Select
                          multiple
                          value={filters?.[TripSalesFilterParams.discountBandAssignments] || []}
                          variant="outlined"
                          displayEmpty
                          SelectDisplayProps={{
                            style: { backgroundColor: 'white', padding: '5px 5px', minHeight: 40 }
                          }}
                          renderValue={(selectedIds: any) => {
                            if (!selectedIds || selectedIds.length === 0) {
                              return <div style={{ color: '#aaa', paddingLeft: 8 }}>{intl.formatMessage({ id: 'all' })}</div>;
                            }

                            return (
                              <Box style={{ display: 'flex', flexWrap: 'wrap' }}>
                                {selectedIds.map(id => {
                                  const opt = assignmentOptions.find(o => o.discount_band_assignments_id === id);

                                  const displayLabel = opt 
                                    ? `${opt.discount_band_name || 'Band'} - ${opt.passengers_group_name || 'Passengers Group'}`
                                    : id;

                                  return (
                                    <Chip 
                                      key={id} 
                                      label={displayLabel} 
                                      style={{ margin: 4 }} 
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setViewingAssignment(opt);
                                      }}
                                      onDelete={() => {
                                        const sel = filters?.[TripSalesFilterParams.discountBandAssignments] || [];
                                        handleAddedFilters(TripSalesFilterParams.discountBandAssignments, sel.filter(s => s !== id));
                                      }} 
                                      onMouseDown={e => e.stopPropagation()} 
                                      icon={<InfoIcon style={{ fontSize: 16 }} />}
                                    />
                                  );
                                })}
                              </Box>
                            );
                          }}
                        >
                          {assignmentOptions.map(opt => (
                            <MenuItem key={opt.discount_band_assignments_id} value={opt.discount_band_assignments_id} onClick={() => {
                              const sel = filters?.[TripSalesFilterParams.discountBandAssignments] || [];
                              const newSel = sel.includes(opt.discount_band_assignments_id) ? sel.filter(s => s !== opt.discount_band_assignments_id) : [...sel, opt.discount_band_assignments_id];
                              handleAddedFilters(TripSalesFilterParams.discountBandAssignments, newSel);
                            }}>
                              <Checkbox checked={(filters?.[TripSalesFilterParams.discountBandAssignments] || []).includes(opt.discount_band_assignments_id)} />

                              <ListItemText primary={`${opt.discount_band_name || 'Band'} - ${opt.passengers_group_name || 'Passengers Group'}`} />

                              <IconButton size="small" onClick={(e) => {
                                e.stopPropagation();
                                setViewingAssignment(opt);
                              }}>
                                <InfoIcon fontSize="small" />
                              </IconButton>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      {/* Detail Dialog */}
                      <Dialog open={!!viewingAssignment} onClose={() => setViewingAssignment(null)} maxWidth="sm" fullWidth style={{ zIndex: 9999 }}>
                        <DialogTitle style={{ backgroundColor: '#F4F6FB', color: '#0daa6e' }}>
                          {intl.formatMessage({ id: 'discountBandAssignments' })}: {viewingAssignment?.discount_band_name}
                        </DialogTitle>

                        <DialogContent dividers style={{ backgroundColor: '#fff' }}>
                          {viewingAssignment && (
                             <Grid container spacing={3} style={{ padding: 10 }}>
                                <Grid item xs={6}>
                                  <Typography variant="caption" color="textSecondary">{intl.formatMessage({ id: 'organization' })}</Typography>

                                  <Typography variant="body2" style={{ fontWeight: 500 }}>{intl.locale === 'ar' ? viewingAssignment.org_ar_name : viewingAssignment.org_en_name}</Typography>
                                </Grid>

                                <Grid item xs={6}>
                                  <Typography variant="caption" color="textSecondary">{intl.formatMessage({ id: 'passengers_group' }) || 'Passengers Group'}</Typography>

                                  <Typography variant="body2" style={{ fontWeight: 500 }}>{viewingAssignment.passengers_group_name}</Typography>
                                </Grid>

                                <Grid item xs={12}><Divider /></Grid>

                                <Grid item xs={12}>
                                  <Typography variant="caption" color="textSecondary">{intl.formatMessage({ id: 'route' })}</Typography>

                                  <Typography variant="body2" style={{ fontWeight: 500 }}>{intl.locale === 'ar' ? viewingAssignment.route_ar_name : viewingAssignment.route_en_name}</Typography>
                                </Grid>

                                { (viewingAssignment.group_en_name || viewingAssignment.group_ar_name) && (
                                  <Grid item xs={12}>
                                    <Typography variant="caption" color="textSecondary">{intl.formatMessage({ id: 'group' })}</Typography>

                                    <Typography variant="body2" style={{ fontWeight: 500 }}>{intl.locale === 'ar' ? viewingAssignment.group_ar_name : viewingAssignment.group_en_name}</Typography>
                                  </Grid>
                                )}

                                <Grid item xs={12}><Divider /></Grid>

                                <Grid item xs={4}>
                                  <Typography variant="caption" color="textSecondary">{intl.formatMessage({ id: 'priority' }) || 'Priority'}</Typography>

                                  <Typography variant="body2" style={{ fontWeight: 500 }}>{viewingAssignment.priority}</Typography>
                                </Grid>

                                <Grid item xs={8}>
                                  <Typography variant="caption" color="textSecondary">{intl.formatMessage({ id: 'validity' }) || 'Validity'}</Typography>

                                  <Typography variant="body2" style={{ fontWeight: 500 }}>
                                    {moment(viewingAssignment.valid_from).format('DD/MM/YYYY')} - {viewingAssignment.valid_to ? moment(viewingAssignment.valid_to).format('DD/MM/YYYY') : '∞'}
                                  </Typography>
                                </Grid>

                                <Grid item xs={12}><Divider /></Grid>

                                <Grid item xs={6}>
                                  <Typography variant="caption" color="textSecondary">{intl.formatMessage({ id: 'createdBy' }) || 'Created By'}</Typography>

                                  <Typography variant="body2" style={{ fontSize: 12 }}>{viewingAssignment.created_by_name}</Typography>
                                </Grid>

                                <Grid item xs={6}>
                                  <Typography variant="caption" color="textSecondary">{intl.formatMessage({ id: 'updatedBy' }) || 'Updated By'}</Typography>

                                  <Typography variant="body2" style={{ fontSize: 12 }}>{viewingAssignment.updated_by_name}</Typography>
                                </Grid>
                             </Grid>
                          )}
                        </DialogContent>

                        <DialogActions>
                          <Button onClick={() => setViewingAssignment(null)} color="secondary" variant="contained">
                            {intl.formatMessage({ id: 'close' })}
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </Grid>
                  </Grid>

                  <div style={{ marginTop: 20 }}>
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.basicButton}
                      onClick={event => {
                        // call filter api with values in state
                        filterTripSales(filters);
                        setAppliedFilters(filters);
                        setOpen(false);
                        event.stopPropagation();
                      }}
                    >
                      {intl.formatMessage({ id: 'apply' })}
                    </Button>

                    <Button
                      variant="text"
                      color="default"
                      className={classes.resetButton}
                      onClick={event => {
                        setFilters({});
                        event.stopPropagation();
                      }}
                    >
                      {intl.formatMessage({ id: 'reset' })}
                    </Button>
                  </div>
                </div>
              </Paper>
            </Fade>
          </ClickAwayListener>
        )}
      </Popper>
    </div>
  );
}

export { Filters };
